
class ApiLoadingStore {
  constructor() {
    this.activeRequests = 0;
    this.listeners = new Set();
  }

  subscribe(listener) {
    this.listeners.add(listener);
    listener(this.activeRequests > 0, this.activeRequests);

    return () => {
      this.listeners.delete(listener);
    };
  }

  startRequest() {
    this.activeRequests += 1;
    this.emit();
  }

  endRequest() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    this.emit();
  }

  clearAll() {
    this.activeRequests = 0;
    this.emit();
  }

  emit() {
    const isLoading = this.activeRequests > 0;
    this.listeners.forEach((listener) => {
      listener(isLoading, this.activeRequests);
    });
  }
}

export const apiLoadingStore = new ApiLoadingStore();